const truthyEnvValues = new Set(["1", "true", "yes", "on"]);

const parseBooleanEnv = (value) =>
  truthyEnvValues.has(String(value ?? "").trim().toLowerCase());

export const isAdminRegistrationEnabled = parseBooleanEnv(
  process.env.REACT_APP_ADMIN_REGISTRATION_ENABLED
);
